import { AvailableRoom } from '../types';

export const getTotalPricesForRooms = (
  allAvailability: (AvailableRoom & { count: number })[][]
) => {
  const roomPriceMap = new Map();
  allAvailability.forEach((rooms) =>
    rooms.forEach(({ count, ...room }) => {
      const currentTotals = roomPriceMap.get(room.id) || {
        price_per_night: {
          ...room.price_per_night,
          amount: 0,
        },
        price_per_stay: {
          ...room.price_per_stay,
          amount: 0,
        },
      };

      roomPriceMap.set(room.id, {
        price_per_night: {
          ...room.price_per_night,
          amount:
            currentTotals.price_per_night.amount + (room.price_per_night?.amount || 0) * count,
        },
        price_per_stay: {
          ...room.price_per_stay,
          amount: currentTotals.price_per_stay.amount + (room.price_per_stay?.amount || 0) * count,
        },
      });
    })
  );
  return roomPriceMap;
};
